import { CreateThemePack, ThemePack, UpdateThemePack } from '@/types/theme-packs.types';
import { Delete, Get, Post, Put } from './helpers';
import abortable from './abortable';

/* These are not the templates you are looking for... */

export const GetThemePacks = (channel: number): Promise<ThemePack[]> => {
  return Get({
    path: `/v3/admin/channel/colors/${channel}`,
    signal: abortable.set('GetThemePacks')?.signal,
  });
};

export const CreateNewColorPack = (colors: CreateThemePack): Promise<ThemePack & { error?: string }> => {
  return Post({ path: `/v3/admin/channel/colors`, body: colors });
};

export const SaveColor = (colors: UpdateThemePack): Promise<ThemePack> => {
  return Put({ path: `/v3/admin/channel/colors`, body: colors });
};

export interface DeleteColorsReturn {
  cannotDelete: number[];
  deletedColors: number[];
}
export const DeleteColors = (
  colorPackIDs: number[],
  channel: number
): Promise<DeleteColorsReturn & { error?: string }> => {
  return Delete({ path: '/v3/admin/channel/colors', body: { colorPackIDs, channel } });
};
